import { FieldError, useFormContext, useWatch } from 'react-hook-form';
import { EntityField, Operator } from '../../../../models/query-builder';
import { useCallback, useEffect, useRef, useState } from 'react';

import { Box, Button, Grid, IconButton } from '@mui/material';

// import LookupColumn from './look-up-column';
import DeleteIcon from '@mui/icons-material/Delete';
import { FormSelect } from '../../hooks-form-querybuilder/form-select.component';
import { CONDITION_OPERATORS } from './conditinal-operator';
import { Add } from '@mui/icons-material';

import FormDateRangePicker from '../../hooks-form-querybuilder/form-date-range.field.component';
import FormDateRangePickerWithName from '../../hooks-form-querybuilder/custom-date-picker/form-date-range.field.component';
import { FormInputNumeric } from '../../hooks-form-querybuilder/form-input-numeric-component';
import LookupColumn from './look-up-column-copy';
import ConfirmDialog from '../../../../components/confirm-dialog';

const dataTypeOperatorCodes: Record<string, string[]> = {
  string: ['=', '!=', 'STARTSWITH', 'ENDSWITH', 'CONTAINS', 'IS NULL', 'IS NOT NULL'],
  date: ['=', '!=', '>', '<', 'Between', 'IS NULL', 'IS NOT NULL'],
  boolean: ['=', '!=', 'IS NULL', 'IS NOT NULL'],
  int: ['='],
};

const hideValueFieldOperatorCodes = ['IS NULL', 'IS NOT NULL'];

interface FilterProps {
  filterKey: string;

  fields: EntityField[];
  operators: Operator[];
  keysCount: number;
  handleDelete: (filterKey: string) => void;
  addNewKey: () => void;
  index: number;
  groupKey: string;
  dependencyIds: {
    [key: string]: string;
  } | null;

  handleDependencyIds: (fieldName: string, ids: string) => void;
}

const getElementById = ({ id, idKey, items = [] }: any) => items.find((item: any) => item[idKey] === id);

const Filter = ({
  groupKey,
  addNewKey,
  fields,
  filterKey,
  handleDelete,
  operators,
  index,
  keysCount,
  dependencyIds,
  handleDependencyIds,
}: FilterProps) => {
  const isFirstItem = index === 0;
  const {
    control,
    unregister,
    formState: { errors },
    setValue,
    getValues,
    watch,
  } = useFormContext();

  const [isDelete, setIsDelete] = useState<boolean>(false);

  useEffect(() => {
    return () => {
      unregister(`groups.${groupKey}.filters.${filterKey}`);
    };
  }, []);

  const optionsRef = useRef<Record<string, any[]>>({});

  const onDelete = useCallback(
    (filterKey: any) => {
      handleDelete(filterKey);
    },
    [handleDelete]
  );

  const handleJoinCondition = useCallback(
    (joinOperator: any) => {
      setValue(`groups.${groupKey}.filters.${filterKey}.joinCondition`, joinOperator);
      if (keysCount === index + 1) {
        addNewKey();
      }
    },
    [keysCount, index, addNewKey]
  );

  const fieldId = useWatch({
    control,
    name: `groups.${groupKey}.filters.${filterKey}.fieldId`,
  });

  const operatorId = useWatch({
    control,
    name: `groups.${groupKey}.filters.${filterKey}.operatorId`,
  });

  const showDelete = keysCount > 1 && keysCount === index + 1;
  const showAdd = keysCount === index + 1;

  const field = getElementById({
    id: fieldId,
    idKey: 'entityFieldId',
    items: fields,
  });

  const filteredOperators = operators.filter((operator) =>
    field?.applicableOperatorCode
      ? field?.applicableOperatorCode?.split(',').includes(operator.operatorCode)
      : dataTypeOperatorCodes[field?.dataType]?.includes(operator.operatorCode)
  );

  const operator = getElementById({
    id: operatorId,
    idKey: 'operatorId',
    items: filteredOperators,
  });

  useEffect(() => {
    if (index === -1) handleJoinCondition(null);
  }, []);

  useEffect(() => {
    if (watch(`groups.${groupKey}.filters.${filterKey}.fieldId`)) {
      const fieldId = watch(`groups.${groupKey}.filters.${filterKey}.fieldId`);
      const fileName = fields?.find((field) => field?.entityFieldId === fieldId)?.fieldName;
      setValue(`groups.${groupKey}.filters.${filterKey}.fieldName`, fileName);
    }
  }, [watch(`groups.${groupKey}.filters.${filterKey}.fieldId`)]);

  // useEffect(() => {
  //   setValue(`groups.${groupKey}.filters.${filterKey}.fieldValue`, '');
  // }, [field?.fieldDisplayName]);

  return (
    <>
      {' '}
      <Box className="quryBuil-grid queryBuildRow">
        <Grid className="queryBuildContainer" container style={{ gap: 5 }}>
          <Box className="icondelete">
            {showDelete && (
              // <IconButton aria-label="delete" size="small" color="error" onClick={() => onDelete(filterKey)}>
              //   <DeleteIcon />
              // </IconButton>
              <Button
                size="small"
                variant="contained"
                onClick={() => setIsDelete(true)}
                color="error"
                sx={{
                  backgroundColor: '#FE7F7F',
                  padding: '0',
                  minWidth: 'auto',
                  width: '25px',
                  height: '25px',
                  borderRadius: '25px',
                }}
              >
                <DeleteIcon />
              </Button>
            )}
          </Box>
          <Grid item xl={3} lg={3} sm={3} xs={12}>
            <FormSelect
              name={`groups.${groupKey}.filters.${filterKey}.joinCondition`}
              options={CONDITION_OPERATORS}
              label="Condition Operator"
              required={!isFirstItem}
              disabled={isFirstItem}
              // sx={{
              //   '&.MuiInputBase-root': {
              //     height: 30,
              //   },
              // }}
            />
          </Grid>
          <Grid item xl={3} lg={3} sm={3} xs={12}>
            <FormSelect
              name={`groups.${groupKey}.filters.${filterKey}.fieldId`}
              options={fields?.map((data: EntityField) => {
                return {
                  value: data?.entityFieldId,
                  label: data?.fieldDisplayName,
                };
              })}
              // disabled={watch(`groups.${groupKey}.filters.${filterKey}.fieldId`) === 1 && keysCount !== 1}
              label="Select Filter"
              required
              onChange={() => {
                setValue(`groups.${groupKey}.filters.${filterKey}.fieldValue`, '');
              }}
            />
          </Grid>
          <Grid item xl={3} lg={3} sm={3} xs={12}>
            <FormSelect
              name={`groups.${groupKey}.filters.${filterKey}.operatorId`}
              // name={`filters.${filterKey}.operatorId`}
              options={filteredOperators?.map((data: Operator) => {
                return {
                  value: data?.operatorId,
                  label: data?.operatorDesc,
                };
              })}
              label="Select Operator"
              onChange={() => setValue(`groups.${groupKey}.filters.${filterKey}.fieldValue`, '')}
              required
            />
          </Grid>
          {field?.dataType === 'date' && (operator?.operatorCode === '=' || operator?.operatorCode === '!=') && (
            <Grid item xl={3} lg={3} sm={3} xs={12}>
              {/* <FormDateField
                name={`filters.${filterKey}.fieldValue`}
                key={filterKey}
                label={field.fieldDisplayName}
                format={DateFormat.SIMPLE_DATE}
                required
              /> */}
              <FormDateRangePickerWithName
                name={`groups.${groupKey}.filters.${filterKey}.fieldValue`}
                key={filterKey}
                label={field.fieldDisplayName}
              />
            </Grid>
          )}
          {field?.dataType === 'date' && operator?.operatorCode === 'Between' && (
            <Grid item xl={3} lg={3} sm={3} xs={12}>
              <FormDateRangePicker
                name={`groups.${groupKey}.filters.${filterKey}.fieldValue`}
                key={filterKey}
                label={field.fieldDisplayName}
                required
              />
            </Grid>
          )}

          {field?.dataType === 'int' && (
            <Grid item xl={3} lg={3} sm={3} xs={12}>
              <FormInputNumeric
                name={`groups.${groupKey}.filters.${filterKey}.fieldValue`}
                key={filterKey}
                label={field.fieldDisplayName}
                required={field?.dataType === 'int'}
                field={field}
                filterKey={filterKey}
                groupKey={groupKey}
              />
            </Grid>
          )}

          {field?.dataType !== 'int' &&
            !(
              field?.dataType === 'date' &&
              (operator?.operatorCode === '=' ||
                operator?.operatorCode === '!=' ||
                operator?.operatorCode === 'Between')
            ) &&
            field &&
            !hideValueFieldOperatorCodes.includes(operator?.operatorCode) && (
              // <div className="fullWidh" style={{ width: 250 }}>
              <Grid item xl={3} lg={3} sm={3} xs={12}>
                <LookupColumn
                  field={field}
                  filterKey={filterKey}
                  groupKey={groupKey}
                  name={`groups.${groupKey}.filters.${filterKey}.fieldValue`}
                  optionsRef={optionsRef}
                  dependencyIds={dependencyIds}
                  handleDependencyIds={handleDependencyIds}
                />
              </Grid>
              // </div>
            )}
        </Grid>
      </Box>
      <Box className="addnewBtn">
        {showAdd && (
          <>
            <IconButton onClick={addNewKey} size="small" color="primary">
              <Add />
            </IconButton>
            <span onClick={addNewKey} style={{ paddingLeft: 12, cursor: 'pointer' }}>
              Add New
            </span>
          </>
        )}
      </Box>
      {isDelete && (
        <ConfirmDialog
          message="Are you sure that you want to remove?"
          onClose={() => setIsDelete(false)}
          onConfirm={() => onDelete(filterKey)}
          open={isDelete}
        />
      )}
    </>
  );
};

export default Filter;
